<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 14:27:21
 * @FilePath: /smartEarthDemo/src/demo/scene/tiltphot.vue
 * @Description: 
-->
<template>
<div style="height:100%">
    <div id="cesiumContainer">
    </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
import util from "../../components/util"
export default {
    data () {
        return {
          viewer:null
        }
    },
    mounted(){
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
       this.init()
    },
    methods: {
        init () {
            this.viewer=util.getViewer('cesiumContainer');
            // var url='http://localhost:9000/model/41dfa310f56811e9a8e2e7f43b4ee6c3/tileset.json';
            var url="/demo/static/data/models/datazhaunhuan/tileset.json";
            let tileset = new Cesium.Cesium3DTileset({
                url: url
            });
                // debugger
            tileset.readyPromise.then( (tileset)=> {
                
                //  let boundingSphere = tileset.boundingSphere;
                var cartographic = Cesium.Cartographic.fromCartesian(tileset.boundingSphere.center);
                var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0);
                var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, -1035);
                var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
                this.viewer.scene.primitives.add(tileset);
                this.viewer.zoomTo(tileset)
            }).otherwise(function (error) {
                throw (error);
            });
        }
    },
}
</script>
<style scoped>
#cesiumContainer{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
</style>